import Search from "../components/Search";

export const SearchRouter = Search;
